export enum TranslationEnum {
    VI = 'vi',
    EN = 'en',
}
